import React, { useState } from "react";
import { Link } from "react-router-dom";
import useAppContext from "state/AppContext";
import { ChevronDownIcon, ChevronUpIcon, ClipboardIcon } from "@heroicons/react/24/solid";
import { Button, CardBody, CardFooter, CardHeader, Typography } from "@material-tailwind/react";

export default function OrderDashboardJobPosting() {
  const appContext = useAppContext();
  const { jobPostingVideo } = appContext.selectedOrder.videos;
  const { jobPosting } = appContext.selectedOrder;
  const { jobTitle, jobLocation, jobTeam, jobSummary } = jobPosting;
  const formattedJobSummary = `${jobSummary.slice(0, 290)}...`;

  const [showContent, setShowContent] = useState(true);

  function handleToggle() {
    setShowContent(!showContent);
  }

  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";
  const buttonStyles = `w-full flex items-stretch justify-between py-4 px-6 ${showContent ? "border-b border-b-gray-300" : ""}`;

  return (
    <div className={containerStyles}>
      <button className={buttonStyles} onClick={handleToggle}>
        <header className="flex items-center flex-1">
          <div className="bg-blue-600 rounded-lg p-1 flex items-center justify-center h-[25px] w-[25px] mr-2">
            <ClipboardIcon className="h-3 w-3 text-white" />
          </div>
          <h3 className="text-lg font-semibold">Job Posting</h3>
        </header>
        <footer className="flex items-center ">
          {showContent ? <ChevronUpIcon className="block h-4 w-4" /> : <ChevronDownIcon className="block h-4 w-4" />}
        </footer>
      </button>
      {showContent ? (
        <div className="p-6">
          <CardHeader floated={false}>
            <iframe
              allowFullScreen
              src={jobPostingVideo.url}
              title={jobPostingVideo.title}
              className="w-full h-[400px] rounded-2xl"
            ></iframe>
          </CardHeader>
          <CardBody>
            <div className="mb-1 flex items-center justify-between">
              <Typography variant="h5" color="blue-gray" className="font-bold">
                {jobTitle}
              </Typography>
            </div>
            <div className="flex mb-2">
              <p className="mb-1 text-sm mx-1">{jobLocation}</p>
              <p className="mb-1 text-sm mx-1">{" • "}</p>
              <p className="mb-1 text-sm mx-1">{jobTeam}</p>
            </div>
            <Typography color="gray">{formattedJobSummary}</Typography>
          </CardBody>
          <CardFooter className="flex justify-center mx-auto">
            <Link to="posting">
              <Button size="lg" className="mt-0 rounded-full">
                View posting
              </Button>
            </Link>
          </CardFooter>
        </div>
      ) : null}
    </div>
  );
}
